import React from 'react';
import soldCangrejo from '../assets/Testimonials/Sold/cangrejo.jpg'
import soldPinuelos from '../assets/Testimonials/Sold/pinuelos.jpg'
import soldAldea from '../assets/Testimonials/Sold/aldea.jpg'
import soldPalma from '../assets/Testimonials/Sold/palma.jpg'
import soldPuertecito from '../assets/Testimonials/Sold/puertecito.jpg'
import SoldOutCard from '../components/SoldOutCard';
import '../styles/SoldOut.css';

const SoldOutGrid = () => {
  const soldData = [
    {
      id: 1,
      soldOutImg: soldCangrejo,
      soldOutTitle: "Cangrejo First Phase",
      soldOutContent: '',
    },

    {
      id: 2,
      soldOutImg: soldPinuelos,
      soldOutTitle: "Piñuelos First Phase",
      soldOutContent: '',
    },

    {
      id: 3,
      soldOutImg: soldAldea,
      soldOutTitle: "Aldea Palmarito",
      soldOutContent: '',
    },

    {
      id: 4,
      soldOutImg: soldPalma,
      soldOutTitle: "Palma Real",
      soldOutContent: '',
    },

    {
      id: 5,
      soldOutImg: soldPuertecito,
      soldOutTitle: "Puertecito Residencial",
      soldOutContent: '',
    },

  ];

  return (
    <div className="sold-out-grid">
      {soldData.map(sold => (
        <SoldOutCard
          key={sold.id}
          soldOutImg={sold.soldOutImg}
          soldOutTitle={sold.soldOutTitle}
          soldOutContent={sold.soldOutContent}
        />
      ))}
    </div>
  );
};

export default SoldOutGrid;